import type {MinimalMessage} from '@/models/messageModel'
import {type MessagePair} from '@/views/Chat/types'

// Deprecated: This function is using to format the chat_history field in /agent/ api, deprecated in use of thread_id
export default function formatChatHistory(messages: MinimalMessage[]) {
  if (messages.length === 0) {
    return []
  }

  return messages.reduce<MessagePair[]>(
    (acc, curr) => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- its guaranteed non-null
      const lastPair = acc[acc.length - 1]!
      const userIsMissing = !lastPair.user
      const assistantIsMissing = !lastPair.assistant
      if (curr.author === 'user') {
        if (userIsMissing) {
          lastPair.user = curr.content
        } else {
          acc.push({
            user: curr.content,
            assistant: '',
          })
        }
      } else if (assistantIsMissing) {
        lastPair.assistant = curr.content
      } else {
        acc.push({
          user: '',
          assistant: curr.content,
        })
      }
      return acc
    },
    [
      {
        user: '',
        assistant: '',
      },
    ],
  )
}
